import { render } from "./AuAccordion.vue?vue&type=template&id=2e9171c6&scoped=true"
import script from "./AuAccordion.vue?vue&type=script&lang=js"
export * from "./AuAccordion.vue?vue&type=script&lang=js"

import "./AuAccordion.vue?vue&type=style&index=0&id=2e9171c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9171c6"]])

export default __exports__